import React, {useState} from "react";

import {Loader} from "../../../components/loading/Loader";
import {StyledTable} from "../../../components/styledTable/StyledTable";
import StyledModal from "../../../components/styledModal/StyledModal";

import {useGetOrdersByEvent} from "../../../services/api/event/order/getOrdersByEvent/useGetOrdersByEvent";
import {useGetEvent} from "../../../services/api/event/getEvent/useGetEvent";
import {useCreateColumns} from "../../../components/styledTable/useCreateColumns";
import {buildColumnData, buildFiltrableColumns} from "../ordersHelper";
import {ExpandedOrder} from "../../../services/api/models/Models";
import {useUpdateCheckInStatus} from "../../../services/api/event/order/updateCheckInStatus/useUpdateCheckInStatus";

import styles from "./OrderCheckIn.module.scss";

export default function OrderCheckIn() {
  const [showUpdateCheckInStatusModal, setShowUpdateCheckInStatusModal] =
    useState(false);
  const [selectedOrder, setSelectedOrder] = useState<ExpandedOrder | null>(
    null
  );
  const selectedOrderIsCheckedIn = selectedOrder?.checkInStatus;

  const {data: orderData, isPending: isOrderDataPending} =
    useGetOrdersByEvent();
  const {data: event, isPending: isEventPending} = useGetEvent();
  const {mutateAsync: updateCheckInStatus, isPending: isUpdatingCheckInStatus} =
    useUpdateCheckInStatus();

  const eventQuestions = event?.eventQuestions ?? [];

  const columnData = useCreateColumns({
    tableData: orderData ?? [],
    columnData: buildColumnData(eventQuestions),
  });

  if (!orderData || !event || isOrderDataPending || isEventPending)
    return <Loader type="color" />;

  const handleRowClick = (row: ExpandedOrder) => {
    setSelectedOrder(row);
    setShowUpdateCheckInStatusModal(true);
  };

  const handleUpdateCheckInStatus = async () => {
    if (!selectedOrder?.id) return;
    const payload = {
      data: {
        eventId: event.event.id,
        orderId: selectedOrder.id,
        checkInStatus: !selectedOrderIsCheckedIn,
      },
    };
    await updateCheckInStatus(payload);
    setShowUpdateCheckInStatusModal(false);
    setSelectedOrder(null);
  };

  return (
    <div className={styles.screen}>
      <StyledTable
        data={orderData ?? []}
        columns={columnData}
        onRowClick={handleRowClick}
        showPagination={true}
        filterableColumns={buildFiltrableColumns(eventQuestions)}
        getRowClassName={(row) =>
          row.original.checkInStatus ? styles.checkedInRow : undefined
        }
      />
      <StyledModal
        title="Update Check In Status"
        text={
          selectedOrderIsCheckedIn
            ? "Are you sure you want to check out this person?"
            : "Are you sure you want to check in this person?"
        }
        open={showUpdateCheckInStatusModal}
        onClose={() => setShowUpdateCheckInStatusModal(false)}
        onContinue={() => handleUpdateCheckInStatus()}
      />
    </div>
  );
}
